import { TerminalName } from '~/services/apiClient'

export const UTAS_ACTIVE_TERMINALS: TerminalName[] = [
  TerminalName.Apm,
  TerminalName.Everport,
  TerminalName.Fms,
  TerminalName.Its,
  TerminalName.Pct,
  TerminalName.PierA,
  TerminalName.Trapac,
  TerminalName.Tti,
  TerminalName.Wbct,
  TerminalName.Yti,
]

export const TERMINALS_REQUIRING_MASTER_BL_FOR_UTAS = new Set<TerminalName>([
  TerminalName.Fms,
  TerminalName.Its,
  TerminalName.Tti,
  TerminalName.Everport,
  TerminalName.Wbct,
])
